import { defineStore } from 'pinia';
import { computed } from 'vue';
import { type Product } from '../domain/product';
import { useEntityStore } from '../../common/composables/entityStore';
import { Assert } from '../../assert';

export const useProductStore = defineStore('products', () => {
  const { add, getById, clear, merge, remove, changed, getOrThrow, list } = useEntityStore<Product>(
    {
      eventName: 'product-changed',
      getEntityId(entity) {
        return entity.id;
      },
      updateEntity(dest, src) {
        dest.name = src.name;
        dest.description = src.description;
        dest.type = src.type;
        dest.color = src.color;
        dest.quality = src.quality;
        dest.logData = src.logData;
        dest.externalCode = src.externalCode;
        dest.coilData = src.coilData;
        dest.bulkData = src.bulkData;
        dest.productGroupId = src.productGroupId;
      },
    },
  );

  function getBulkUnit(productId: string) {
    var product = list.value.find((p) => p.id == productId);
    Assert.definied(product?.bulkData);
    return product.bulkData.unit;
  }

  function getBulkDensity(productId: string) {
    var product = list.value.find((p) => p.id == productId);
    Assert.definied(product?.bulkData);
    return product.bulkData.density;
  }

  return {
    changed,
    getById,
    add,
    remove,
    getOrThrow,
    merge,
    clear,
    getBulkUnit,
    getBulkDensity,
    products: list,
    sortedByName: computed(() => {
      const clone = Array.from(list.value);
      clone.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
      return clone;
    }),
  };
});
